<template>
  <b-card title="">
    <h4 class="text-primary font-weight-bold mb-2">
      ค้นหา Request number / alcode
    </h4>
    <b-row>
      <b-col md="12">
        <b-form-group label="Request number" label-for="reqcode">
          <b-form-input id="reqcode" v-model="formUser.reqcode" placeholder="Request number" :class="{
            'is-invalid': showError && !formUser.reqcode && !formUser.alCode,
          }" />
          <b-form-invalid-feedback v-if="showError && !formUser.reqcode && !formUser.alCode">
            กรุณากรอก Request number หรือ alCode อย่างน้อยหนึ่งช่อง
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group label="alCode" label-for="alCode">
          <b-form-input id="alCode" v-model="formUser.alCode" placeholder="alCode" :class="{
            'is-invalid': showError && !formUser.reqcode && !formUser.alCode,
          }" />
          <b-form-invalid-feedback v-if="showError && !formUser.reqcode && !formUser.alCode">
            กรุณากรอก Request number หรือ alCode อย่างน้อยหนึ่งช่อง
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>

    <b-col cols="12" class="mb-3">
      <b-button variant="primary" @click.prevent="Getdata"> ค้นหา </b-button>
    </b-col>

    <h4 class="text-primary font-weight-bold mb-2">นำเข้าด้วยไฟล์</h4>
    <b-col md="12">
      <div>
        <!-- Styled -->
        <b-form-file v-model="file" @change="handleFileChange" placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..." accept=".csv, .xlsx, .xls" class="mb-3" />
      </div>
      <b-form-invalid-feedback v-if="showErrorfile">
        กรุณาเลือกไฟล์ .xlsx หรือ .csv ก่อนดำเนินการต่อ
      </b-form-invalid-feedback>
    </b-col>

    <b-col cols="12" class="mb-3">
      <b-button variant="primary" @click.prevent="Getdatafile">
        นำเข้าด้วยไฟล์
      </b-button>
    </b-col>
    <b-col md="6">
      <h4 class="text-primary font-weight-bold mb-2">ข้อมูลแรงานต่างด้าว</h4>
    </b-col>
    <b-row class="mb-2">
      <b-col md="6" sm="4" class="my-1">
        <b-form-group class="mb-0">
          <label class="d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
          class="mb-0">
          <b-input-group size="sm">
            <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                ยกเลิก
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <hr />

    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered">
        <!-- Header checkbox (Select All) -->
        <template #head(select)>
          <b-form-checkbox :indeterminate="isIndeterminate" :checked="allSelected"
            @change="toggleSelectAll"></b-form-checkbox>
        </template>

        <!-- Checkbox per row -->
        <template #cell(select)="row">
          <b-form-checkbox v-model="row.item._selected" @change="updateSelectAllState"></b-form-checkbox>
        </template>
      </b-table>
    </b-col>

    <b-row class="justify-content-center mt-3">
      <b-col cols="8" class="d-flex justify-content-center">
        <b-button variant="success" @click="MakeQueue" :disabled="!hasSelected"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'">
          ดำเนินการต่อ
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import Ripple from "vue-ripple-directive";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import * as XLSX from "xlsx";

const BASE_URL = process.env.BASE_URL;
const NAMELIST_URL = process.env.NAMELIST_URL;
const TOKEN_URL = process.env.TOKEN_URL;
const API_KEY = "nrK2GCAAazpRI2UCtI$SCfBd9XBg8EYS";
const API_SECRET = "nrK2GCAAazpRI2UCtI$GGGGG";

export default {
  directives: {
    Ripple,
  },
  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      fields: [
        { key: "select", label: "", sortable: false },
        { key: "No.", label: "ลำดับที่" },
        { key: "alcode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
        { key: "Prefix", label: "คำนำหน้า" },
        { key: "Username", label: "ชื่อ" },
        { key: "Surname", label: "นามสกุล" },
        { key: "Sex", label: "เพศ" },
        { key: "DateofBirth", label: "วันเดือนปีเกิด" },
        // { key: "status", label: "วันเกิด" },
        // { key: "action", label: "Print" }, // ✅ เพิ่มตรงนี้
      ],
      items: [],
      selected: null,
      showError: false,
      showErrorfile: false,
      formUser: {
        reqcode: "",
        alCode: "",
      },
      file: null,
      excelData: [],
      excelHeader: [],
    };
  },
  computed: {
    allSelected() {
      return (
        this.items.length > 0 && this.items.every((item) => item._selected)
      );
    },
    isIndeterminate() {
      const total = this.items.length;
      const selected = this.items.filter((i) => i._selected).length;
      return selected > 0 && selected < total;
    },
    hasSelected() {
      return this.items.some((item) => item._selected);
    },
  },
  created() {
    const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      console.log(jwt);
    // this.getDataTable();
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    validate() {
      if (!this.formUser.reqcode && !this.formUser.alCode) {
        this.showError = true;
        return false;
      }

      //  this.showError = false;
      return true;
    },
    validatefile() {
      const valid = !!this.file;
      this.showErrorfile = !valid;
      return valid;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    // onFiltered(filteredItems) {
    //   // Trigger pagination to update the number of buttons/pages due to filtering
    //   this.totalRows = filteredItems.length;
    //   this.currentPage = 1;
    // },

    onFiltered(filteredItems) {
      // Optional: handle filtered results
    },
    handleFileChange(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      this.showErrorfile = false;
      this.excelData = [];
      reader.onload = (evt) => {
        const data = evt.target.result;
        const workbook = XLSX.read(data, { type: "binary" });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

        const convertedData = jsonData.map((row, index) => {
          const newRow = Object.entries(row).reduce((acc, [key, value]) => {
            if (key === "DateofBirth" && typeof value === "number") {
              acc[key] = this.excelDateToJSDate(value);
            } else if (typeof value === "number") {
              acc[key] = value.toString();
            } else {
              acc[key] = value;
            }
            return acc;
          }, {});
          return newRow;
        });

        console.log("Parsed JSON data from Excel:", convertedData);

        if (convertedData.length > 0) {
          this.excelHeader = Object.keys(convertedData[0]);
          console.log("Excel Header:", this.excelHeader);
        }

        this.excelData = convertedData;
      };

      reader.readAsBinaryString(file);
    },

    excelDateToJSDate(serial) {
      const utc_days = Math.floor(serial - 25569);
      const utc_value = utc_days * 86400;
      const date_info = new Date(utc_value * 1000);
      const day = String(date_info.getDate()).padStart(2, '0');
      const month = String(date_info.getMonth() + 1).padStart(2, '0');
      const year = date_info.getFullYear();
      return `${day}/${month}/${year}`;
    },
    toggleSelectAll(checked) {
      this.items.forEach((item) => {
        item._selected = checked;
      });
      this.updateSelectAllState();
    },
    updateSelectAllState() {
      // Vue will recalculate allSelected and isIndeterminate automatically
      // const total = this.items.length;
      // const selected = this.items.filter((i) => i._selected).length;
      // this.allSelected = selected === total;
      // this.isIndeterminate = selected > 0 && selected < total;
    },
    encodeBase64(key, secret) { Buffer.from(`${key}:${secret}`).toString('base64') },
    async fetchAccessToken() {
      try {
        const encodedCredentials = encodeBase64(API_KEY, API_SECRET);

        const response = await axios.post(
          `${BASE_URL}${TOKEN_URL}`,
          { method: "authorize" },
          {
            headers: {
              Authorization: `Basic ${encodedCredentials}`,
            },
          }
        );

        const { token, expiresIn } = response.data;
        tokenCache.accessToken = token;
        tokenCache.expiresAt = Date.now() + expiresIn * 1000;

        return token;
      } catch (error) {
        console.error(
          "Failed to fetch access token:",
          error.response?.data || error.message
        );
        throw new Error("Authorization failed");
      }
    },
    async getValidAccessToken() {
      if (!tokenCache.accessToken || Date.now() >= tokenCache.expiresAt) {
        return await fetchAccessToken();
      }
      return tokenCache.accessToken;
    },
    async Getdata() {
      console.log("ssss");
      if (!this.validate()) return;
      //   const _acc =  await store.dispatch("TOKEN_CONNECT");
      //   console.log(_acc);
      const token = await getValidAccessToken();
      const requestBody = {
        reqcode: this.reqcode,
        alcode: this.alcode,
        // altype: altype,
      };

      console.log(requestBody);

      const response = await axios.post(
        `${BASE_URL}${NAMELIST_URL}`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    },
    async Getdatafile() {
      console.log("Selected file:", this.file);
      if (!this.validatefile()) return;

      console.log("Selected file:", this.file);
      this.items = this.excelData.map((item) => {
        return {
          ...item,
          _selected: false, // เพิ่ม property สำหรับ checkbox
        };
      });

      //   const _acc =  await store.dispatch("TOKEN_CONNECT");
      //   console.log(_acc);
    },
    async MakeQueue() {
      const selectedUsers = this.items.filter((item) => item._selected);
      console.log(selectedUsers);
      store.commit("addChang", selectedUsers);

      //  localStorage.setItem("data_addqueue",selectedUsers);

      this.$router.push({ name: "addqueue" });
      // หรือใช้ตามงาน: ส่ง API, แสดง modal, ลบ ฯลฯ
    },

    async getDataTable() {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
    //  console.log(jwt);
      await axios
        .get(
          `${API}allUserFromCompany?companyId=${jwt.companyId}&userId=${jwt.userId}`,
          {
            headers: {
              Authorization: await store.dispatch("getAuthorization"),
            },
          }
        )
        .then((res) => {
          console.log("✅ success");
          console.log(res.data.message[0]);
          //  this.items = res.data.message[0].results;
          this.items = res.data.message[0].results.map((user) => ({
            ...user,
            _selected: false,
          }));
          console.log(this.items);
        })
        .catch((err) => {
          if (err.response) {
            console.error("❌ API Error:", err.response.status);
            console.error("Response:", err.response.data);
          } else {
            console.error("❌ Error:", err.message);
          }
        });
    },
    async validationForm() {
      const { username, password, firstname, lastname } = this.formUser;
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
    //  console.log(jwt);

      const _data = new FormData();
      _data.append("companyId", jwt.companyId);
      _data.append("username", username);
      _data.append("password", password);
      _data.append("role", this.selected);
      _data.append("firstname", firstname);
      _data.append("lastname", lastname);
      console.log("ddddddddddddd");

      console.log(username);
      console.log(password);
      console.log(this.selected);
      console.log(firstname);
      console.log(lastname);

      axios
        .post(`${API}registerUser`, _data, {
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        })
        .then(async (res) => {
          console.log(res);
          if (res.data.message == "Registration user is complete.") {
            this.$swal({
              icon: "success",
              title: "บันทึกข้อมูล!",
              text: "บันทึกข้อมูลสำเร็จ",
              showCancelButton: false,
              showConfirmButton: true,
              timer: 1500,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
            this.getDataTable();
          }
        })
        .catch(async (error) => {
          console.log(error.response);
          this.$store.commit("setToastMessage", {
            message: `${error.response.data.message}`,
            title: "ผู้ใช้งาน limit",
            variant: "danger",
          });
        });
    },
  },
};
</script>